<script setup lang="ts">
import { useListItem } from "@/hooks";
interface Panel {
  key: string;
}

defineProps<{
  panels: Panel[];
  active: string;
}>();

useListItem();
</script>
<template>
  <div class="mp-list-multi-panel">
    <template v-for="item in panels" :key="item.key">
      <div v-show="item.key === active" class="mp-multi-panel__item">
        <slot :name="item.key" />
      </div>
    </template>
  </div>
</template>
<style lang="scss">
.mp-list-multi-panel {
  &,
  &__item {
    height: 100%;
  }
}
</style>
